import React from 'react';
import './Cell.css';


const Cell = (props) => {
    return (
        <div className={props.className} >
        </div>
    );
};

export default Cell;